export class SecurityGroupReference {
    public securityGroupId: string;
    public securityGroupName: string;
    public statusCode: string;
    public commitByName: string;
    public commitDateTime: Date;
}